import axiosInstance from '../axiosInstance'

export const login = async (email: string, password: string): Promise<{ two_factor: boolean }> => {
    const params = {
        email,
        password,
        user_type: 'admin',
    }

    const response = await axiosInstance.post('login', params)

    return {
        two_factor: response.data.two_factor || false,
    }
}

export const logout = async (): Promise<void> => {
    await axiosInstance.post('logout')
}

export const twoFactorChallenge = async (code: string): Promise<void> => {
    const data = {
        code,
    }

    await axiosInstance.post('two-factor-challenge', data)
}

export const forgotPassword = async (email: string): Promise<void> => {
    await axiosInstance.post('forgot-password', { email })
}

export const resetPassword = async (email: string, token: string, password: string, passwordConfirmation: string): Promise<void> => {
    await axiosInstance.post('reset-password', { email, token, password, password_confirmation: passwordConfirmation })
}

export const changePassword = async (form: { currentPassword: string, password: string, passwordConfirmation: string }): Promise<void> => {
    await axiosInstance.put('user/password', { current_password: form.currentPassword, password: form.password, password_confirmation: form.passwordConfirmation })
}